import { useMemo } from 'react'

/**
 * Check if user has required contact information (email + phone number)
 * @param {object} user - User object with email field
 * @param {object} primaryPlayer - Primary player object with phone_number field
 * @returns {object} { hasContactInfo: boolean, missingFields: string[] }
 */
export default function useContactInfoCheck(user, primaryPlayer) {
  return useMemo(() => {
    if (!user || !primaryPlayer) {
      return { hasContactInfo: false, missingFields: ['email', 'phone_number'] }
    }

    const missingFields = []

    // Check email (from user)
    if (!user.email || user.email.trim() === '') {
      missingFields.push('email')
    }

    // Check phone number (from player)
    if (
      !primaryPlayer.phone_number ||
      primaryPlayer.phone_number.trim() === ''
    ) {
      missingFields.push('phone_number')
    }

    return {
      hasContactInfo: missingFields.length === 0,
      missingFields,
    }
  }, [user, primaryPlayer])
}
